import axios from "axios";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import config from "../config";
import MapComponent from "./MapComponent";
import {
  Input,
  Button,
  Upload,
  List,
  Row,
  Col,
  Skeleton,
  notification,
} from "antd";
import { UploadOutlined, CloseCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import InputMask from "react-input-mask";

import vaidateNameAndDOB from "../validators/StepOne";
import validateStepTwo from "../validators/StepTwo";
import Payment from "./Payment";
import zipcodes from "../helpers/zipcodes.json";

const openNotification = (errMessage) => {
  notification.open({
    message: "Error",
    description: errMessage,
    onClick: () => {
      console.log("Notification Clicked!");
    },
    icon: <CloseCircleOutlined style={{ color: "red" }} />,
  });
};

const PersonalInfo = (props) => {
  const { stepOne, stepTwo } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pharmacies, setPharmacies] = useState([]);
  const [pharmacyToDisplay, setPharmacyToDisplay] = useState([]);
  const [pharmacy, setPharmacy] = useState({});
  const [error, setError] = useState("");
  const [manualPharmacy, setManualPharmacy] = useState({
    name: "",
    address: "",
  });
  const [dateError, setDateError] = useState(false);
  const [errorStepOne, setErrorStepOne] = useState({});
  const [errorStepTwo, setErrorStepTwo] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [errors, setErrors] = useState({});
  const [zipCodeToSearch, setZipCodeToSearch] = useState(stepTwo.zipcode);
  const [activeTab, setActiveTab] = useState(0);
  const [searchValue, setSearch] = useState(null);
  const [localDob, setLocalDob] = useState(stepOne.dob || "");

  // Debug log
  console.log("Initial stepOne.dob:", stepOne.dob);
  console.log("Initial localDob:", localDob);

  useEffect(() => {
    // If stepOne.dob exists and is a moment object, format it
    if (
      stepOne.dob &&
      typeof stepOne.dob === "object" &&
      stepOne.dob._isAMomentObject
    ) {
      setLocalDob(moment(stepOne.dob).format("MM/DD/YYYY"));
    } else if (stepOne.dob && typeof stepOne.dob === "string") {
      setLocalDob(stepOne.dob);
    }
  }, [stepOne.dob]);

  const changeForm = (name, value) => {
    setError(false);
    let temp = stepOne;
    temp[name] = value;
    dispatch({ type: "SET_STEP_ONE", stepOne: { ...temp } });
  };
  const changeStepTwo = (name, value) => {
    if (name === "phoneNumber") {
      setErrorStepTwo({ ...errorStepTwo, phoneNumber: false });
    }
    if (name === "zipcode") {
      setZipCodeToSearch(value);
    }
    let temp = stepTwo;
    temp[name] = value;
    dispatch({ type: "SET_STEP_TWO", stepTwo: { ...temp } });
  };
  const submitStepOne = async (e) => {
    try {
      e.preventDefault();
      const errorsStepOne = vaidateNameAndDOB(stepOne);
      if (
        errorsStepOne.firstName ||
        errorsStepOne.lastName ||
        errorsStepOne.dob ||
        errorsStepOne.identityNumber ||
        errorsStepOne.identityPictures
      ) {
        setErrorStepOne(errorsStepOne);
        return;
      }
      setLoading(true);
      if (!error) {
        const { data } = await axios.post(
          `${config.baseUrl}request/get-request-by-name`,
          {
            identityNumber: stepOne.identityNumber.replace(/[^a-zA-Z0-9]/g, ""),
          }
        );
        if (!data.request.length) {
          setLoading(false);
          setStep(step + 1);
        } else {
          setError(
            `It seems you have already requested a prescription in last ${data.settings[0].prescriptionWindow} days. You cannot request a new prescription at this time.`
          );
          setLoading(false);
        }
      } else {
        setStep(step + 1);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const submitStepTwo = async (e) => {
    try {
      e.preventDefault();
      const errors = validateStepTwo(stepTwo);
      if (
        errors.email ||
        errors.phoneNumber ||
        errors.street ||
        errors.city ||
        errors.state ||
        errors.zipcode ||
        errors.identityPictures
      ) {
        setErrorStepTwo(errors);
        return;
      }
      if (!zipcodes[stepTwo.zipcode]) {
        openNotification("Please enter a valid Florida zip code");
        return;
      }
      setLoading(true);
      if (activeTab === 0) {
        if (stepTwo.zipcode) {
          defaultPharmacies(searchValue);
        }
      } else {
        getNearByPharmacies(searchValue);
      }
      setZipCodeToSearch(stepTwo.zipcode);
      setStep(step + 1);
    } catch (err) {
      setLoading(false);
    }
  };
  const defaultPharmacies = async (name = "") => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${config.baseUrl}places/${
          zipCodeToSearch || stepTwo.zipcode
        }?name=${name}`
      );
      setPharmacies(data);
      setPharmacyToDisplay(data);
      setPharmacy(data[activeIndex]);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      openNotification(err.response.data.msg);
    }
  };
  const selectPharmacy = () => {
    if (
      manualPharmacy.name ||
      manualPharmacy.address ||
      manualPharmacy.phoneNumber
    ) {
      if (
        manualPharmacy.name &&
        manualPharmacy.address &&
        manualPharmacy.phoneNumber
      ) {
        dispatch({
          type: "SET_STEP_THREE",
          stepThree: { ...{ pharmacy: manualPharmacy } },
        });
        props.dispatchFormValues({
          ...stepOne,
          ...stepTwo,
          ...{ pharmacy: manualPharmacy },
        });
        setErrors({});
        setStep(step + 1);
      }
      let errorsToDisplay = errors;
      if (!manualPharmacy.name) {
        errorsToDisplay = {
          ...errorsToDisplay,
          name: "Please enter a name for the desired pharmacy",
        };
      } else {
        errorsToDisplay = {
          ...errorsToDisplay,
          name: "",
        };
      }
      if (!manualPharmacy.address) {
        errorsToDisplay = {
          ...errorsToDisplay,
          address: "Please enter a address for the pharmacy",
        };
      } else {
        errorsToDisplay = {
          ...errorsToDisplay,
          address: "",
        };
      }
      if (!manualPharmacy.phoneNumber) {
        errorsToDisplay = {
          ...errorsToDisplay,
          phoneNumber: "Please enter a phone number for the pharmacy",
        };
      } else {
        errorsToDisplay = {
          ...errorsToDisplay,
          phoneNumber: "",
        };
      }
      setErrors(errorsToDisplay);
    } else {
      if (pharmacies.length === 0) {
        setErrors({
          ...errors,
          name: "Please enter a name for the desired pharmacy",
          address: "Please enter an address for the pharmacy",
          phoneNumber: "Please enter a phone number for the pharmacy",
        });
        return;
      }
      const { name, formatted_address, vicinity } = pharmacy;
      dispatch({
        type: "SET_STEP_THREE",
        stepThree: {
          ...{ pharmacy: { name, address: formatted_address || vicinity } },
        },
      });
      props.dispatchFormValues({
        ...stepOne,
        ...stepTwo,
        ...{ pharmacy: { name, address: formatted_address || vicinity } },
      });
      setStep(step + 1);
    }
  };
  const addFront = ({ file }) => {
    if (file.status !== "removed") {
      let reader = new FileReader();
      reader.onload = (e) => {
        let pictures = stepOne.identityPictures || {};
        pictures.front = {
          uid: file.uid,
          url: e.target.result,
          name: file.name,
        };
        dispatch({
          type: "SET_STEP_ONE",
          stepOne: {
            ...stepOne,
            ...{
              identityPictures: pictures,
            },
          },
        });
      };
      reader.readAsDataURL(file.originFileObj);
    }
  };
  const addBack = ({ file }) => {
    if (file.status !== "removed") {
      let reader = new FileReader();
      reader.onload = (e) => {
        let pictures = stepOne.identityPictures || {};
        pictures.back = {
          uid: file.uid,
          url: e.target.result,
          name: file.name,
        };
        dispatch({
          type: "SET_STEP_ONE",
          stepOne: {
            ...stepOne,
            ...{
              identityPictures: pictures,
            },
          },
        });
      };
      reader.readAsDataURL(file.originFileObj);
    }
  };
  const removePicture = (index) => {
    let pictures = stepOne.identityPictures;
    if (index === 0) {
      delete pictures.front;
    } else {
      delete pictures.back;
    }
    dispatch({
      type: "SET_STEP_ONE",
      stepOne: {
        ...stepOne,
        ...{
          identityPictures: pictures,
        },
      },
    });
  };
  const search = (e) => {
    const { value } = searchValue;
    if (activeTab === 0) {
      setSearch(value);
      defaultPharmacies(value);
    } else {
      setSearch(searchValue);
      getNearByPharmacies(searchValue);
    }
  };
  const changePharmacy = (pharmacy, index) => {
    setPharmacy(pharmacy);
    setManualPharmacy({
      name: "",
      address: "",
    });
    setActiveIndex(index);
  };
  const dobChanged = (e) => {
    console.log("dobChanged input value:", e.target.value); // Debug log

    setDateError(false);
    setErrorStepOne({ ...errorStepOne, dob: false });

    // Always update local state
    setLocalDob(e.target.value);

    if (e.target.value.length === 0) {
      const temp = { ...stepOne, dob: "" };
      dispatch({
        type: "SET_STEP_ONE",
        stepOne: temp,
      });
      return;
    }

    const now = moment();
    const dob = moment(e.target.value, "MM/DD/YYYY", true);

    if (dob.isValid()) {
      const age = now.diff(dob, "years");
      console.log("Calculated age:", age); // Debug log

      if (age < 18 || age > 65) {
        setDateError(true);
      } else {
        const temp = { ...stepOne, dob: e.target.value };
        console.log("Setting stepOne.dob to:", e.target.value); // Debug log

        dispatch({
          type: "SET_STEP_ONE",
          stepOne: temp,
        });
      }
    } else {
      console.log("Invalid date format"); // Debug log
    }
  };
  const changeZipCode = async (e) => {
    setZipCodeToSearch(e.target.value);
  };
  const searchZipCode = async (e) => {
    try {
      e.preventDefault();
      if (zipCodeToSearch) {
        setLoading(true);
        const url = searchValue
          ? `${config.baseUrl}places/${zipCodeToSearch}?name=${searchValue}`
          : `${config.baseUrl}places/${zipCodeToSearch}`;
        const { data } = await axios.get(url);
        setPharmacies(data);
        setPharmacyToDisplay(data);
        setActiveIndex(0);
        setPharmacy(data[0]);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      openNotification(err.response.data.msg || err.message);
    }
  };
  const goBack = async () => {
    if (step === 0) {
      props.decrementStep();
    } else {
      setStep(step - 1);
      if (step - 1 === 2) {
        setLoading(true);
        // const { data } = await axios.get(
        //   `${config.baseUrl}places/${stepTwo.zipcode}`
        // );
        if (activeTab === 0) {
          if (zipCodeToSearch) {
            defaultPharmacies(searchValue);
          } else {
            setZipCodeToSearch(stepTwo.zipcode);
            defaultPharmacies(searchValue);
          }
        } else {
          getNearByPharmacies(searchValue);
        }
      }
    }
  };
  const getNearByPharmacies = async (name = "") => {
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { data } = await axios.get(
          `${config.baseUrl}places/${position.coords.latitude}/${position.coords.longitude}?name=${name}`
        );
        setPharmacies(data);
        setPharmacyToDisplay(data);
        setPharmacy(data[activeIndex]);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
        openNotification(error.message || error.response.data.msg);
      }
    );
  };

  useEffect(() => {
    if (step === 2) {
      // setActiveTab(0);
      dispatch({
        type: "SET_STEP_THREE",
        stepThree: { ...{ pharmacy: {} } },
      });
    }
  }, [step, dispatch]);

  useEffect(() => {
    if (activeTab === 0) {
      if (zipCodeToSearch) {
        defaultPharmacies(searchValue);
      }
    } else {
      getNearByPharmacies(searchValue);
    }
  }, [activeTab]);

  return (
    <div className="column">
      <div className="back-container">
        <p className="link-button" onClick={() => goBack()}>
          Go Back
        </p>
      </div>
      <div
        className="responsive"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className="tabs">
          <div
            className={step === 0 ? "tab active sub-title" : "tab sub-title"}
            onClick={() => setStep(0)}
          >
            Personal Info
          </div>
          <div
            className={step === 1 ? "tab active sub-title" : "tab sub-title"}
            onClick={() => (step > 1 ? setStep(1) : null)}
          >
            Additional Info
          </div>
          <div
            className={step === 2 ? "tab active sub-title" : "tab sub-title"}
            onClick={() => (step > 2 ? setStep(2) : null)}
          >
            Pharmacy
          </div>
          <div
            className={step === 3 ? "tab active sub-title" : "tab sub-title"}
            onClick={() => (step > 3 ? setStep(3) : null)}
          >
            Payment
          </div>
        </div>
        <Col span={24}>
          {step === 0 && (
            <form>
              <div className="justify-space-between">
                <Col>
                  <label className={"helper-message m-b-10-px m-t-10-px"}>
                    First Name
                  </label>
                  <Input
                    placeholder={"First Name"}
                    type="text"
                    onChange={(e) => changeForm(e.target.name, e.target.value)}
                    name="firstName"
                    value={stepOne.firstName}
                  />
                  {errorStepOne.firstName && (
                    <small className="error-message">
                      {errorStepOne.firstName}
                    </small>
                  )}
                </Col>
                <Col>
                  <label className={"helper-message m-b-10-px m-t-10-px"}>
                    Middle Name (optional)
                  </label>
                  <Input
                    placeholder={"Middle Name"}
                    type="text"
                    onChange={(e) => changeForm(e.target.name, e.target.value)}
                    name="middleName"
                    value={stepOne.middleName}
                  />
                </Col>
                <Col>
                  <label className={"helper-message m-b-10-px m-t-10-px"}>
                    Last Name
                  </label>
                  <Input
                    placeholder={"Last Name"}
                    type="text"
                    onChange={(e) => changeForm(e.target.name, e.target.value)}
                    name="lastName"
                    value={stepOne.lastName}
                  />
                  {errorStepOne.lastName && (
                    <small className="error-message">
                      {errorStepOne.lastName}
                    </small>
                  )}
                </Col>
              </div>
              <Row className="flex column">
                <label className={"helper-message m-b-10-px m-t-10-px"}>
                  Date of Birth
                </label>
                <InputMask
                  mask="99/99/9999"
                  name="dob"
                  value={localDob}
                  onChange={(e) => dobChanged(e)}
                  placeholder="MM/DD/YYYY"
                >
                  {(inputProps) => <Input {...inputProps} />}
                </InputMask>
                {errorStepOne.dob && (
                  <small className="error-message">{errorStepOne.dob}</small>
                )}
                {dateError && (
                  <small className="error-message">
                    You should be between the age of 18 and 65 years to
                    continue.
                  </small>
                )}
              </Row>
              <div className="flex column m-b-10-px m-t-10-px">
                <label className="helper-message m-b-0-px m-t-10-px">
                  License or Photo ID # (required)
                </label>
                <small className="description-message">
                  Please enter you driver's license number WITHOUT dashes.
                </small>
                <Input
                  name="identityNumber"
                  value={stepOne.identityNumber}
                  onChange={(e) => changeForm(e.target.name, e.target.value)}
                />
                {errorStepOne.identityNumber && (
                  <small className="error-message">
                    Please enter you driver's license number WITHOUT dashes.
                  </small>
                )}
              </div>
              <div className="m-b-10-px m-t-10-px">
                <label className={"helper-message m-b-10-px m-t-10-px"}>
                  Identification Document
                </label>
                <small className="description-message">
                  Upload your drivers license or legal photo ID issued by your
                  state, that includes your name, date of birth etc
                </small>
                <div className="upload-button">
                  <Upload
                    onChange={(e) => addFront(e)}
                    customRequest={({ file, onSuccess }) => {
                      setTimeout(() => {
                        onSuccess("ok");
                      }, 0);
                    }}
                    accept="image/*"
                    fileList={
                      stepOne.identityPictures?.front
                        ? [stepOne.identityPictures.front]
                        : []
                    }
                    defaultFileList={[]}
                    listType="picture"
                    onRemove={(file) => removePicture(0)}
                    onPreview={(file) => {}}
                  >
                    <Button icon={<UploadOutlined />}>Upload Front</Button>
                  </Upload>
                </div>
                <div className="upload-button">
                  <Upload
                    onChange={(e) => addBack(e)}
                    customRequest={({ file, onSuccess }) => {
                      setTimeout(() => {
                        onSuccess("ok");
                      }, 0);
                    }}
                    accept="image/*"
                    fileList={
                      stepOne.identityPictures?.back
                        ? [stepOne.identityPictures.back]
                        : []
                    }
                    defaultFileList={[]}
                    listType="picture"
                    onRemove={(file) => removePicture(1)}
                    onPreview={(file) => {}}
                  >
                    <Button icon={<UploadOutlined />}>Upload Back</Button>
                  </Upload>
                  <small className="error-message">
                    {errorStepOne.identityPictures}
                  </small>
                </div>
                {/* <input
                  type="file"
                  onChange={(e) =>
                    changeStepTwo("identityPhoto", e.target.files[0])
                  }
                /> */}
              </div>
              <p className="error-message">{error}</p>
              <Button
                loading={loading}
                onClick={(e) => submitStepOne(e)}
                disabled={dateError || error}
                type="primary"
                style={{ backgroundColor: "#0064A9" }}
              >
                Continue
              </Button>
            </form>
          )}
          {step === 1 && (
            <div>
              <form>
                <div>
                  <label className={"helper-message"}>Email</label>
                  <Input
                    type="email"
                    name="email"
                    onChange={(e) =>
                      changeStepTwo(e.target.name, e.target.value)
                    }
                    value={stepTwo.email}
                  />
                  {errorStepTwo.email && (
                    <small className="error-message">
                      {errorStepTwo.email}
                    </small>
                  )}
                </div>
                <div>
                  <label className={"helper-message"}>Phone Number</label>

                  <InputMask
                    mask="(999) 999-9999"
                    name="phoneNumber"
                    value={stepTwo.phoneNumber}
                    onChange={(e) =>
                      changeStepTwo(e.target.name, e.target.value)
                    }
                    placeholder="(999) 999-9999"
                  >
                    {(inputProps) => <Input {...inputProps} />}
                  </InputMask>
                  {errorStepTwo.phoneNumber && (
                    <small className="error-message">
                      {errorStepTwo.phoneNumber}
                    </small>
                  )}
                </div>
                <div>
                  <label className={"helper-message"}>Street</label>
                  <Input
                    type="text"
                    name="street"
                    onChange={(e) =>
                      changeStepTwo(e.target.name, e.target.value)
                    }
                    value={stepTwo.street}
                  />
                  {errorStepTwo.street && (
                    <small className="error-message">
                      {errorStepTwo.street}
                    </small>
                  )}
                </div>
                <div className="justify-space-between">
                  <div>
                    <label className={"helper-message"}>City</label>
                    <Input
                      type="text"
                      name="city"
                      onChange={(e) =>
                        changeStepTwo(e.target.name, e.target.value)
                      }
                      value={stepTwo.city}
                    />
                    {errorStepTwo.city && (
                      <small className="error-message">
                        {errorStepTwo.city}
                      </small>
                    )}
                  </div>
                  <div>
                    <label className={"helper-message"}>State</label>
                    <Input
                      type="text"
                      name="state"
                      onChange={(e) =>
                        changeStepTwo(e.target.name, e.target.value)
                      }
                      value={stepTwo.state}
                    />
                    {errorStepTwo.state && (
                      <small className="error-message">
                        {errorStepTwo.state}
                      </small>
                    )}
                  </div>
                  <div>
                    <label className={"helper-message"}>Zip Code</label>
                    <Input
                      type="text"
                      name="zipcode"
                      onChange={(e) =>
                        changeStepTwo(e.target.name, e.target.value)
                      }
                      value={stepTwo.zipcode}
                    />
                    {errorStepTwo.zipcode && (
                      <small className="error-message">
                        {errorStepTwo.zipcode}
                      </small>
                    )}
                  </div>
                </div>

                <Button
                  disabled={loading}
                  loading={loading}
                  onClick={(e) => submitStepTwo(e)}
                  type="primary"
                  style={{ marginTop: "10px", backgroundColor: "#0064A9" }}
                >
                  Continue
                </Button>
              </form>
            </div>
          )}
          {step === 2 && (
            <>
              <h3 style={{ lineHeight: 2 }}>
                Search for your pharmacy by name and/or ZIP code below
              </h3>
              <div style={{ display: "flex" }}>
                <div className="full-width-on-mobile">
                  <div className="flex custom-tabs">
                    <div
                      className={
                        activeTab === 0 ? "custom-tab tab-active" : "custom-tab"
                      }
                      onClick={() => {
                        if (loading) return;
                        setActiveTab(0);
                        setActiveIndex(0);
                      }}
                    >
                      <span>By Zip Code</span>
                    </div>
                    <div
                      className={
                        activeTab === 1 ? "custom-tab tab-active" : "custom-tab"
                      }
                      onClick={() => {
                        if (loading) return;
                        setActiveIndex(0);
                        setActiveTab(1);
                      }}
                    >
                      <span>Nearby</span>
                    </div>
                  </div>
                  <div className="search-zipcode">
                    <div className="search">
                      <label className="helper-message">Pharmacy Name</label>
                      <Input
                        name="search"
                        // onKeyPress={(e) => search(e)}
                        value={searchValue}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    {activeTab === 0 && (
                      <div className="search">
                        <label className={"helper-message"}>Zip Code</label>
                        <Input
                          name="zipCodeToSearch"
                          onChange={(e) => changeZipCode(e)}
                          // onKeyPress={(e) => searchZipCode(e)}
                          value={zipCodeToSearch}
                        />
                      </div>
                    )}
                  </div>
                  <div className="search-button">
                    <Button
                      type="primary"
                      disabled={loading}
                      style={{
                        marginBottom: "10px",
                        width: "100%",
                        height: "10%",
                      }}
                      onClick={(e) => {
                        if (loading) return;
                        if (activeTab === 0) {
                          searchZipCode(e);
                        } else {
                          search(e);
                        }
                      }}
                    >
                      Search
                    </Button>
                  </div>
                  <div
                    style={{
                      maxHeight: "50vh",
                      width: "100%",
                      overflow: "scroll",
                    }}
                    className="places"
                  >
                    {loading ? (
                      <>
                        <Skeleton paragraph={{ rows: 1 }} />
                        <Skeleton paragraph={{ rows: 1 }} />
                        <Skeleton paragraph={{ rows: 1 }} />
                        <Skeleton paragraph={{ rows: 1 }} />
                      </>
                    ) : (
                      <List
                        dataSource={pharmacyToDisplay}
                        renderItem={(item, index) => (
                          <List.Item
                            onClick={() => changePharmacy(item, index)}
                            className={
                              activeIndex === index ? "active-pharmacy" : ""
                            }
                          >
                            <List.Item.Meta
                              title={item.name}
                              description={`${
                                item.formatted_address || item.vicinity
                              } ${
                                item.formatted_phone_number
                                  ? ` | ${item.formatted_phone_number}`
                                  : ""
                              }`}
                            />
                          </List.Item>
                        )}
                      />
                    )}
                    {errors.pharmacy && (
                      <small className="error-message">{errors.pharmacy}</small>
                    )}
                  </div>

                  <Button
                    type="primary"
                    onClick={() => selectPharmacy()}
                    style={{ marginTop: "10px", backgroundColor: "#0064A9" }}
                    disabled={loading}
                  >
                    Continue
                  </Button>
                </div>
                {pharmacy && (
                  <MapComponent
                    lat={pharmacy?.geometry?.location?.lat || 0}
                    lng={pharmacy?.geometry?.location?.lng || 0}
                    style={{ maxWidth: "50%" }}
                    className="hide-on-mobile"
                  />
                )}
              </div>
            </>
          )}
          {step === 3 && (
            <Payment
              incrementStep={props.incrementStep}
              decrementStep={props.decrementStep}
            />
          )}
        </Col>
      </div>
    </div>
  );
};

export default PersonalInfo;
